/**
 * Official Spanish translations for Pokémon Moves (WikiDex/Official Game Localization)
 * Mapping: PokeAPI slug -> Spanish Name
 */
export const MOVES_ES = {
  // === COMMON & COMPETITIVE ===
  'thunderbolt': 'Rayo',
  'ice-beam': 'Rayo Hielo',
  'flamethrower': 'Lanzallamas',
  'surf': 'Surf',
  'earthquake': 'Terremoto',
  'protect': 'Protección',
  'toxic': 'Tóxico',
  'will-o-wisp': 'Fuego Fatuo',
  'thunder-wave': 'Onda Trueno',
  'stealth-rock': 'Trampa Rocas',
  'spikes': 'Púas',
  'toxic-spikes': 'Púas Tóxicas',
  'sticky-web': 'Red Viscosa',
  'nasty-plot': 'Maquinación',
  'swords-dance': 'Danza Espada',
  'dragon-dance': 'Danza Dragón',
  'quiver-dance': 'Danza Aleteo',
  'calm-mind': 'Paz Mental',
  'bulk-up': 'Corpulencia',
  'hone-claws': 'Afilagarras',
  'iron-defense': 'Defensa Férrea',
  'agility': 'Agilidad',
  'roost': 'Respiro',
  'recover': 'Recuperación',
  'soft-boiled': 'Amortiguador',
  'milk-drink': 'Batido',
  'shore-up': 'Recogearena',
  'slack-off': 'Relajo',
  'wish': 'Deseo',
  'healing-wish': 'Deseo Cura',
  'lunar-dance': 'Danza Lunar',
  'teleport': 'Teletransporte',
  'u-turn': 'Ida y Vuelta',
  'volt-switch': 'Voltiocambio',
  'flip-turn': 'Viraje',
  'parting-shot': 'Última Palabra',
  'knock-off': 'Desarme',
  'scald': 'Escaldar',
  'defog': 'Despejar',
  'rapid-spin': 'Giro Rápido',
  'brave-bird': 'Pájaro Osado',
  'flare-blitz': 'Envite Ígneo',
  'wood-hammer': 'Mazazo',
  'wave-crash': 'Envite Acuático',
  'extreme-speed': 'Velocidad Extrema',
  'fake-out': 'Sorpresa',
  'sucker-punch': 'Golpe Bajo',
  'close-combat': 'A bocajarro',
  'superpower': 'Fuerza Bruta',
  'drain-punch': 'Puño Drenaje',
  'mach-punch': 'Ultrapuño',
  'bullet-punch': 'Puño Bala',
  'shadow-sneak': 'Sombra Vil',
  'aqua-jet': 'Acua Jet',
  'ice-shard': 'Canto Helado',
  'rock-blast': 'Pedrada',
  'icicle-spear': 'Carámbano',
  'bullet-seed': 'Recurrente',
  'tails-slap': 'Plumerazo',
  'dual-wingbeat': 'Ala Bis',
  'dragons-maw': 'Mandíbula Dragón', // Ability? Move name maybe differs? Wait.
  // Correction:
  'dragon-darts': 'Draco Flechas',
  'dragon-pulse': 'Pulso Dragón',
  'draco-meteor': 'Cometa Draco',
  'outrage': 'Enfado',
  'fire-blast': 'Llamarada',
  'overheat': 'Sofoco',
  'fire-punch': 'Puño Fuego',
  'thunder-punch': 'Puño Trueno',
  'ice-punch': 'Puño Hielo',
  'wild-charge': 'Voltio Cruel',
  'thunder': 'Trueno',
  'hurricane': 'Vendaval',
  'hydro-pump': 'Hidrobomba',
  'blizzard': 'Ventisca',
  'leaf-storm': 'Lluevehojas',
  'giga-drain': 'Gigadrenado',
  'energy-ball': 'Energibola',
  'solar-beam': 'Rayo Solar',
  'sludge-bomb': 'Bomba Lodo',
  'sludge-wave': 'Onda Tóxica',
  'focus-blast': 'Onda Certera',
  'aura-sphere': 'Esfera Aural',
  'shadow-ball': 'Bola Sombra',
  'dark-pulse': 'Pulso Umbrío',
  'moonblast': 'Fuerza Lunar',
  'dazzling-gleam': 'Brillo Mágico',
  'psychic': 'Psíquico',
  'psyshock': 'Psicocarga',
  'expanding-force': 'Vasta Fuerza',
  'future-sight': 'Premonición',
  'doom-desire': 'Deseo Oculto',
  'fleur-cannon': 'Cañón Floral',
  'flash-cannon': 'Foco Resplandor',
  'bug-buzz': 'Zumbido',
  'u-turn': 'Ida y Vuelta',
  'first-impression': 'Escaramuza',
  'lunge': 'Plancha',
  'leech-life': 'Chupavidas',
  'stone-edge': 'Roca Afilada',
  'rock-slide': 'Avalancha',
  'power-gem': 'Joyas de Luz',
  'meteor-beam': 'Rayo Meteórico',

  // === STATUS & STRATEGY ===
  'taunt': 'Mofa',
  'encore': 'Otra Vez',
  'disable': 'Anulación',
  'torment': 'Tormento',
  'embargo': 'Embargo',
  'heal-block': 'Anticura',
  'trick': 'Truco',
  'switcheroo': 'Trapicheo',
  'substitute': 'Sustituto',
  'protect': 'Protección',
  'detect': 'Detección',
  'spiky-shield': 'Barrera Espinosa',
  'kings-shield': 'Escudo Real',
  'baneful-bunker': 'Búnker',
  'obstruct': 'Obstrucción',
  'silky-glow': 'Resplandor Seda', //?
  'silk-trap': 'Trampa Seda',
  'burning-bulwark': 'Baluarte Ígneo',
  'helping-hand': 'Refuerzo',
  'follow-me': 'Señuelo',
  'rage-powder': 'Polvo Ira',
  'fake-tears': 'Llanto Falso',
  'metal-sound': 'Eco Metálico',
  'tailwind': 'Viento Afín',
  'trick-room': 'Espacio Raro',
  'gravity': 'Gravedad',
  'wonder-room': 'Zona Extraña',
  'magic-room': 'Zona Mágica',
  'sunny-day': 'Día Soleado',
  'rain-dance': 'Danza Lluvia',
  'sandstorm': 'Tormenta de Arena',
  'hail': 'Granizo',
  'snowscape': 'Paisaje Nevado',
  'electric-terrain': 'Campo Eléctrico',
  'grassy-terrain': 'Campo de Hierba',
  'misty-terrain': 'Campo Niebla',
  'psychic-terrain': 'Campo Psíquico',
  'mist': 'Neblina',
  'haze': 'Niebla',
  'safeguard': 'Velo Sagrado',
  'light-screen': 'Pantalla de Luz',
  'reflect': 'Reflejo',
  'aurora-veil': 'Velo Aurora',

  // === ATTACKS (A-Z BY ENGLISH) ===
  'absorb': 'Absorber',
  'accelerock': 'Roca Veloz',
  'acid': 'Ácido',
  'acid-armor': 'Armadura Ácida',
  'acid-spray': 'Bomba Ácida',
  'acrobatics': 'Acróbata',
  'aerial-ace': 'Golpe Aéreo',
  'aeroblast': 'Aerochorro',
  'air-slash': 'Tajo Aéreo',
  'ancient-power': 'Poder Pasado',
  'apple-acid': 'Ácido Málico',
  'aqua-cutter': 'Tajo Acuático',
  'aqua-ring': 'Acua Aro',
  'aqua-step': 'Danza Acuática',
  'aqua-tail': 'Acua Cola',
  'arm-thrust': 'Empujón',
  'armor-cannon': 'Cañón Armadura',
  'aromatherapy': 'Aromaterapia',
  'assurance': 'Vendetta',
  'astonish': 'Impresionar',
  'astral-barrage': 'Espectro de la Noche',
  'attack-order': 'Al Ataque',
  'attract': 'Atracción',
  'aurora-beam': 'Rayo Aurora',
  'avalanche': 'Alud',
  'baby-doll-eyes': 'Ojitos Tiernos',
  'barrage': 'Bombardeo',
  'barrier': 'Barrera',
  'baton-pass': 'Relevo',
  'beak-blast': 'Pico Cañón',
  'beat-up': 'Paliza',
  'belch': 'Eructo',
  'belly-drum': 'Tambor',
  'bide': 'Venganza',
  'bind': 'Atadura',
  'bite': 'Mordisco',
  'blast-burn': 'Anillo Ígneo',
  'blaze-kick': 'Patada Ígnea',
  'bleakwind-storm': 'Vendaval Gélido',
  'blood-moon': 'Luna Roja',
  'blue-flare': 'Llama Azul',
  'body-press': 'Plancha Corporal',
  'body-slam': 'Golpe Cuerpo',
  'bolt-beak': 'Electropico',
  'bolt-strike': 'Ataque Fulgor',
  'bone-club': 'Hueso Palo',
  'bone-rush': 'Ataque Óseo',
  'bonemerang': 'Huesomerang',
  'boomburst': 'Estruendo',
  'bounce': 'Bote',
  'branch-poke': 'Rama en el Ojo',
  'breaking-swipe': 'Vasto Impacto',
  'brick-break': 'Demolición',
  'brine': 'Salmuera',
  'brutal-swing': 'Giro Vil',
  'bubble': 'Burbuja',
  'bubble-beam': 'Rayo Burbuja',
  'bug-bite': 'Picadura',
  'burning-jealousy': 'Envidia Ardiente',
  'burn-up': 'Llama Final',
  'ceaseless-edge': 'Tajo Metralla',
  'charge': 'Carga',
  'charge-beam': 'Rayo Carga',
  'charm': 'Encanto',
  'chatter': 'Cháchara',
  'chilling-water': 'Frío Polar', // Wait. Chilling Water is...
  'chilling-water': 'Agua Fría',
  'chloroblast': 'Cloroblasto',
  'circle-throw': 'Tiro Vital', // Circle Throw is Llave Círculo.
  'circle-throw': 'Llave Círculo',
  'clamor': 'Clamor',
  'clear-smog': 'Niebla Clara',
  'collision-course': 'Nitrochoque',
  'comet-punch': 'Puño Cometa',
  'confuse-ray': 'Rayo Confuso',
  'confusion': 'Confusión',
  'copycat': 'Copión',
  'core-enforcer': 'Núcleo Castigo',
  'cosmic-power': 'Masa Cósmica',
  'cotton-guard': 'Rizo Algodón',
  'cotton-spore': 'Espora Algodón',
  'counter': 'Contrataque',
  'crabhammer': 'Martillazo',
  'cross-chop': 'Tajo Cruzado',
  'cross-poison': 'Veneno X',
  'crunch': 'Triturar',
  'crush-claw': 'Garra Brutal',
  'crush-grip': 'Agarrón',
  'curse': 'Maldición',
  'cut': 'Corte',
  'darkest-lariat': 'Lariat Oscuro',
  'dark-void': 'Brecha Negra',
  'decore': 'Decoración',
  'destiny-bond': 'Mismo Destino',
  'diamond-storm': 'Tormenta de Diamantes',
  'dig': 'Excavar',
  'dire-claw': 'Garra Virulenta',
  'disarming-voice': 'Voz Cautivadora',
  'discharge': 'Chispazo',
  'dive': 'Buceo',
  'doodle': 'Garabato',
  'double-edge': 'Doble Filo',
  'double-hit': 'Doble Golpe',
  'double-iron-bash': 'Puño Doble Férreo',
  'double-kick': 'Doble Patada',
  'double-slap': 'Doblebofetón',
  'double-team': 'Doble Equipo',
  'dragon-breath': 'Dragoaliento',
  'dragon-claw': 'Garra Dragón',
  'dragon-energy': 'Energía Dragón',
  'dragon-hammer': 'Martillo Dragón',
  'dragon-rush': 'Carga Dragón',
  'dragon-tail': 'Cola Dragón',
  'drain-kiss': 'Beso Drenaje',
  'dream-eater': 'Comesueños',
  'drill-peck': 'Pico Taladro',
  'drill-run': 'Taladradora',
  'drum-beating': 'Batería Asaltante',
  'dynamic-punch': 'Puñodinámico',
  'earth-power': 'Tierra Viva',
  'eerie-impulse': 'Onda Anómala',
  'eerie-spell': 'Conjuro Extraño',
  'egg-bomb': 'Bomba Huevo',
  'electro-ball': 'Bola Voltio',
  'electro-drift': 'Electroderrape',
  'electroweb': 'Electrotela',
  'elemental-fists': 'Puños Elementales',
  'elemental-punches': 'Puños Elementales',
  'ember': 'Ascuas',
  'endeavor': 'Esfuerzo',
  'endure': 'Aguante',
  'energy-ball': 'Energibola',
  'entrainment': 'Danza Amiga',
  'eruption': 'Estallido',
  'esper-wing': 'Ala Psíquica',
  'eternabeam': 'Rayogénesis',
  'extrasensory': 'Paranormal',
  'facade': 'Imagen',
  'fairy-lock': 'Cerrojo Hada',
  'fairy-wind': 'Viento Feérico',
  'false-surrender': 'Falsa Rendición',
  'false-swipe': 'Falsotortazo',
  'feather-dance': 'Danza Pluma',
  'fiery-dance': 'Danza Llama',
  'fiery-wrath': 'Furia Ardiente',
  'fire-fang': 'Colmillo Ígneo',
  'fire-lash': 'Latigazo Ígneo',
  'fire-spin': 'Giro Fuego',
  'first-impression': 'Escaramuza',
  'fissure': 'Fisura',
  'flail': 'Azote',
  'flame-charge': 'Nitrocarga',
  'flame-wheel': 'Rueda Fuego',
  'flare-blitz': 'Envite Ígneo',
  'flash': 'Destello',
  'flatter': 'Adulación',
  'fleur-cannon': 'Cañón Floral',
  'fling': 'Lanzamiento',
  'float-fall': 'Salto Flotante',
  'flower-trick': 'Truco Floral',
  'fly': 'Vuelo',
  'flying-press': 'Plancha Voladora',
  'focus-energy': 'Foco Energía',
  'focus-punch': 'Puño Certero',
  'force-palm': 'Palmeo',
  'foul-play': 'Juego Sucio',
  'freeze-dry': 'Liofilización',
  'freezing-glare': 'Mirada Gélida',
  'frenzy-plant': 'Planta Feroz',
  'frost-breath': 'Vaho Gélido',
  'fury-attack': 'Ataque Furia',
  'fury-cutter': 'Corte Furia',
  'fury-swipes': 'Golpes Furia',
  'fusion-bolt': 'Ataque Fulgor',
  'fusion-flare': 'Llama Fusión',
  'gear-grind': 'Rueda Doble',
  'gear-up': 'Piñón Auxiliar',
  'geargrind': 'Rueda Doble',
  'geomancy': 'Geocontrol',
  'giga-drain': 'Gigadrenado',
  'giga-impact': 'Giga Impacto',
  'gigaton-hammer': 'Martillo Gigante',
  'glacial-lance': 'Lanza Glacial',
  'glaciate': 'Mundo Gélido',
  'glare': 'Deslumbrar',
  'glitzy-glow': 'Resplandor Mágico',
  'grass-knot': 'Hierba Lazo',
  'grass-pledge': 'Voto Planta',
  'grass-whistle': 'Silbato',
  'grassy-glide': 'Fitoimpulso',
  'growl': 'Gruñido',
  'growth': 'Desarrollo',
  'guillotine': 'Guillotina',
  'gunk-shot': 'Lanza Mugre',
  'gust': 'Tornado',
  'gyro-ball': 'Giro Bola',
  'hammer-arm': 'Machada',
  'hard-press': 'Presión Firme',
  'harden': 'Fortaleza',
  'head-charge': 'Ariete',
  'headbutt': 'Golpe Cabeza',
  'head-long-rush': 'Arremetida',
  'head-smash': 'Testarazo',
  'heart-stamp': 'Arrumaco',
  'heart-swap': 'Cambio Almas',
  'heat-crash': 'Golpe Calor',
  'heat-wave': 'Onda Ígnea',
  'heavy-slam': 'Cuerpo Pesado',
  'high-horsepower': 'Fuerza Equina',
  'high-jump-kick': 'Patada Salta Alta',
  'hold-back': 'Clemencia',
  'hold-hands': 'Manos Juntas',
  'horn-attack': 'Cornada',
  'horn-drill': 'Perforador',
  'horn-leech': 'Asta Drenaje',
  'howl': 'Aullido',
  'hydro-cannon': 'Hidrocañón',
  'hydro-pump': 'Hidrobomba',
  'hyper-beam': 'Hiperrayo',
  'hyper-drill': 'Hiper Taladro',
  'hyper-fang': 'Hipercolmillo',
  'hyper-voice': 'Vozarrón',
  'hypnosis': 'Hipnosis',
  'ice-ball': 'Bola Hielo',
  'ice-beam': 'Rayo Hielo',
  'ice-fang': 'Colmillo Hielo',
  'ice-hammer': 'Martillo Hielo',
  'ice-punch': 'Puño Hielo',
  'ice-shard': 'Canto Helado',
  'ice-spinner': 'Pirueta Helada',
  'icicle-crash': 'Chuzos',
  'icicle-spear': 'Carámbano',
  'icy-wind': 'Viento Hielo',
  'imprison': 'Sello',
  'incinerate': 'Calcinación',
  'infernal-parade': 'Marcha Espectral',
  'inferno': 'Infierno',
  'infestation': 'Acoso',
  'ingrain': 'Arraigo',
  'invisible-hand': 'Mano Invisible',
  'iron-defense': 'Defensa Férrea',
  'iron-head': 'Cabeza de Hierro',
  'iron-tail': 'Cola Férrea',
  'jaw-lock': 'Presa Maxilar',
  'judgment': 'Sentencia',
  'jump-kick': 'Patada Salto',
  'jungle-healing': 'Cura Selvática',
  'karate-chop': 'Golpe Karata',
  'kinesis': 'Kinético',
  'knock-off': 'Desarme',
  'kowtow-cleave': 'Genuflexión',
  'last-resort': 'Última Baza',
  'last-respects': 'Homenaje Póstumo',
  'lava-plume': 'Erupción', // No, Lava Plume is Humeareda.
  'lava-plume': 'Humareda',
  'leaf-age': 'Follaje',
  'leaf-blade': 'Hoja Aguda',
  'leaf-storm': 'Lluevehojas',
  'leaf-tornado': 'Ciclón de Hojas',
  'leafage': 'Follaje',
  'leech-life': 'Chupavidas',
  'leech-seed': 'Drenadoras',
  'leer': 'Malicioso',
  'lick': 'Lengüetazo',
  'light-of-ruin': 'Luz Aniquiladora',
  'light-screen': 'Pantalla de Luz',
  'liquidation': 'Hidroariete',
  'lock-on': 'Fijar Blanco',
  'lovely-kiss': 'Beso Amoroso',
  'low-kick': 'Patada Baja',
  'low-sweep': 'Puntapié',
  'lucky-chant': 'Conjuro',
  'lumina-crash': 'Choque Lumínico',
  'lunge': 'Plancha',
  'luster-purge': 'Resplandor',
  'mach-punch': 'Ultrapuño',
  'magical-leaf': 'Hoja Mágica',
  'magma-storm': 'Lluvia Ígnea',
  'magnet-bomb': 'Bomba Imán',
  'magnet-rise': 'Levitón',
  'magnetic-flux': 'Flux Magnético',
  'magnitude': 'Magnitud',
  'make-it-rain': 'Fiebre Dorada',
  'malicious-moonsault': 'Hiperplancha Oscura',
  'mean-look': 'Mal de Ojo',
  'meditate': 'Meditación',
  'mega-drain': 'Megaagotar',
  'mega-kick': 'Megapatada',
  'mega-punch': 'Megapuño',
  'megahorn': 'Megacuerno',
  'memento': 'Legado',
  'metal-claw': 'Garra Metal',
  'metal-sound': 'Eco Metálico',
  'meteor-beam': 'Rayo Meteórico',
  'meteor-mash': 'Puño Meteoro',
  'metronome': 'Metrónomo',
  'milk-drink': 'Batido',
  'mimic': 'Mimético',
  'mind-blown': 'Cabeza Sorpresa',
  'mind-reader': 'Telépata',
  'minimize': 'Reducción',
  'miracle-eye': 'Gran Ojo',
  'mirror-coat': 'Manto Espejo',
  'mirror-move': 'Movimiento Espejo',
  'mirror-shot': 'Disparo Espejo',
  'mist': 'Neblina',
  'mist-ball': 'Bola Neblina',
  'misty-explosion': 'Explosión Brumosa',
  'moonblast': 'Fuerza Lunar',
  'moonlight': 'Luz Lunar',
  'morning-sun': 'Sol Matinal',
  'mortal-spin': 'Giro Mortífero',
  'mountain-gale': 'Vendaval Montañoso',
  'mud-bomb': 'Bomba Lodo',
  'mud-shot': 'Disparo Lodo',
  'mud-slap': 'Bofetón Lodo',
  'mud-sport': 'Mud Sport', // No.
  'mud-sport': 'Chapoteolodo',
  'muddy-water': 'Agua Lodosa',
  'multi-attack': 'Multiataque',
  'mystical-fire': 'Fuego Místico',
  'mystical-power': 'Poder Místico',
  'nasty-plot': 'Maquinación',
  'natural-gift': 'Don Natural',
  'nature-power': 'Adaptación',
  'nature-madness': 'Furia Natural',
  'needle-arm': 'Brazo Pincho',
  'night-daze': 'Pulso Noche',
  'night-shade': 'Tinieblas',
  'night-slash': 'Tajo Umbrío',
  'nightmare': 'Pesadilla',
  'no-retreat': 'No Hay Escapatoria',
  'noble-roar': 'Rugido de Guerra',
  'nuzzle': 'Moflete Estático',
  'obstruct': 'Obstrucción',
  'octazooka': 'Octazuka',
  'octolock': 'Octopresa',
  'ominous-wind': 'Viento Aciago',
  'order-up': 'Marcha',
  'origin-pulse': 'Pulso Primigenio',
  'outrage': 'Enfado',
  'overdrive': 'Amplificador',
  'overheat': 'Sofoco',
  'pain-split': 'Divide Dolor',
  'parabolic-charge': 'Carga Parábola',
  'parting-shot': 'Última Palabra',
  'pay-day': 'Día de Pago',
  'payback': 'Vendetta',
  'peck': 'Picotazo',
  'perish-song': 'Canto Mortal',
  'petal-dance': 'Danza Pétalo',
  'petal-blizzard': 'Tormenta de Pétalos',
  'phantom-force': 'Golpe Fantasma',
  'photon-geyser': 'Geiser Fotónico',
  'pika-papow': 'Pika-Papow',
  'pin-missile': 'Pin Misil',
  'plasma-fists': 'Puños Plasma',
  'play-nice': 'Camaradería',
  'play-rough': 'Carantoña',
  'pluck': 'Picoteo',
  'poison-fang': 'Colmillo Veneno',
  'poison-gas': 'Gas Venenoso',
  'poison-jab': 'Puya Nociva',
  'poison-powder': 'Polvo Veneno',
  'poison-sting': 'Picotazo Venenoso',
  'poison-tail': 'Cola Veneno',
  'pollen-puff': 'Bola de Polen',
  'poltergeist': 'Poltergeist',
  'population-bomb': 'Prole de Bombas',
  'pounce': 'Brinco',
  'pound': 'Destructor',
  'powder': 'Polvo',
  'powder-snow': 'Nieve Polvo',
  'power-gem': 'Joyas de Luz',
  'power-shift': 'Cambio Fuerza',
  'power-split': 'Compartir Fuerza',
  'power-swap': 'Cambio Fuerza',
  'power-trick': 'Truco Fuerza',
  'power-trip': 'Chulería',
  'power-whip': 'Latigazo',
  'precipice-blades': 'Filo del Abismo',
  'present': 'Presente',
  'prismatic-laser': 'Láser Prisma',
  'psybeam': 'Psicorrayo',
  'psych-up': 'Más Psique',
  'psychic': 'Psíquico',
  'psychic-fangs': 'Psicocolmillo',
  'psychic-noise': 'Ruido Psíquico',
  'psychic-terrain': 'Campo Psíquico',
  'psycho-cut': 'Psicocorte',
  'psycho-shift': 'Psicocambio',
  'psyshock': 'Psicocarga',
  'psystrike': 'Onda Mental',
  'psywave': 'Psicoonda',
  'punishment': 'Castigo',
  'purify': 'Purificación',
  'pursuit': 'Persecución',
  'pyro-ball': 'Balón Ígneo',
  'quash': 'Último Lugar',
  'quick-attack': 'Ataque Rápido',
  'rage': 'Furia',
  'rage-fist': 'Puño Furia',
  'rage-powder': 'Polvo Ira',
  'rain-dance': 'Danza Lluvia',
  'rapid-spin': 'Giro Rápido',
  'razor-leaf': 'Hoja Afilada',
  'razor-shell': 'Concha Filo',
  'razor-wind': 'Viento Cortante',
  'recover': 'Recuperación',
  'recycle': 'Reciclaje',
  'reflect': 'Reflejo',
  'reflect-type': 'Copiatipo',
  'refresh': 'Alivio',
  'relic-song': 'Canto Arcaico',
  'rest': 'Descanso',
  'retaliate': 'Represalia',
  'return': 'Retribución',
  'revelation-dance': 'Danza Revelación',
  'revival-blessing': 'Plegaria Vital',
  'revenge': 'Desquite',
  'reversal': 'Inversión',
  'roar': 'Rugido',
  'roar-of-time': 'Distorsión',
  'rock-blast': 'Pedrada',
  'rock-climb': 'Treparrocas',
  'rock-polish': 'Pulimento',
  'rock-slide': 'Avalancha',
  'rock-smash': 'Golpe Roca',
  'rock-throw': 'Lanzarrocas',
  'rock-tomb': 'Tumba Rocas',
  'rock-wrecker': 'Romperrocas',
  'role-play': 'Imitación',
  'rolling-kick': 'Patada Giro',
  'rollout': 'Desenrollar',
  'roost': 'Respiro',
  'round': 'Canon',
  'ruination': 'Furia Ruinosa',
  'sacred-fire': 'Fuego Sagrado',
  'sacred-sword': 'Espada Santa',
  'safeguard': 'Velo Sagrado',
  'sand-attack': 'Ataque Arena',
  'sand-tomb': 'Bucle Arena',
  'sandstorm': 'Tormenta de Arena',
  'scald': 'Escaldar',
  'scary-face': 'Cara Susto',
  'scorch-sands': 'Arenas Ardientes',
  'scratch': 'Arañazo',
  'screech': 'Chirrido',
  'searing-shot': 'Bomba Ígnea',
  'searing-sunraze-smash': 'Embestida Solar',
  'secret-power': 'Daño Secreto',
  'secret-sword': 'Sable Místico',
  'seed-bomb': 'Bomba Germen',
  'seed-flare': 'Fogonazo',
  'seismic-toss': 'Movimiento Sísmico',
  'self-destruct': 'Autodestrucción',
  'shadow-ball': 'Bola Sombra',
  'shadow-bone': 'Hueso Sombrío',
  'shadow-claw': 'Garra Sombría',
  'shadow-force': 'Golpe Umbrío',
  'shadow-punch': 'Puño Sombra',
  'shadow-sneak': 'Sombra Vil',
  'sharpen': 'Afilar',
  'shattered-psyche': 'Disrupción Psíquica',
  'shed-tail': 'Autonomía',
  'sheer-cold': 'Frío Polar',
  'shell-side-arm': 'Moluscañón',
  'shell-smash': 'Rompecoraza',
  'shell-trap': 'Coraza Trampa',
  'shelter': 'Refugio',
  'shock-wave': 'Onda Voltio',
  'shore-up': 'Recogearena',
  'signal-beam': 'Rayo Señal',
  'silky-glow': 'Resplandor Seda',
  'silver-wind': 'Viento Plata',
  'simple-beam': 'Onda Simple',
  'sing': 'Canto',
  'sinister-arrow-raid': 'Aluvión de Flechas Sombrías',
  'sir-skitter-leap': 'Asalto Escurridizo',
  'skull-bash': 'Cabezazo',
  'sky-attack': 'Ataque Aéreo',
  'sky-drop': 'Caída Libre',
  'sky-uppercut': 'Gancho Alto',
  'slack-off': 'Relajo',
  'slam': 'Portazo',
  'slash': 'Cuchillada',
  'sleep-powder': 'Somnífero',
  'sleep-talk': 'Sonámbulo',
  'sludge': 'Residuos',
  'sludge-bomb': 'Bomba Lodo',
  'sludge-wave': 'Onda Tóxica',
  'smack-down': 'Antiaéreo',
  'smart-strike': 'Cuerno Certero',
  'smelling-salts': 'Estímulo',
  'smog': 'Polución',
  'smokescreen': 'Pantalla de Humo',
  'snap-trap': 'Cepo',
  'snarl': 'Alarido',
  'snatch': 'Robo',
  'snipe-shot': 'Disparo Certero',
  'snore': 'Ronquido',
  'snowscape': 'Paisaje Nevado',
  'soak': 'Anegar',
  'soft-boiled': 'Amortiguador',
  'solar-beam': 'Rayo Solar',
  'solar-blade': 'Cuchilla Solar',
  'sonic-boom': 'Bomba Sónica',
  'soul-stealing-7-star-strike': 'Constelación Central',
  'spacial-rend': 'Corte Vacío',
  'spark': 'Chispa',
  'sparkling-aria': 'Aria Burbuja',
  'spectral-thief': 'Robasombra',
  'speed-swap': 'Cambio Velocidad',
  'spicy-extract': 'Extracto Picante',
  'spider-web': 'Telaraña',
  'spikes': 'Púas',
  'spiky-shield': 'Barrera Espinosa',
  'spirit-break': 'Choque de Almas',
  'spirit-shackle': 'Puntada Sombría',
  'spit-up': 'Escupir',
  'spite': 'Rencor',
  'splash': 'Salpicadura',
  'splintered-stormshards': 'Tempestad Rocosa',
  'splishy-splash': 'Surf Surf',
  'spore': 'Espora',
  'spotlight': 'Foco',
  'springtide-storm': 'Vendaval de Primavera',
  'stealth-rock': 'Trampa Rocas',
  'steam-burst': 'Chorro de Vapor',
  'steamroller': 'Rodillo de Púas',
  'steel-beam': 'Rayto de Acero',
  'steel-roller': 'Rodillo de Acero',
  'steel-wing': 'Ala de Acero',
  'sticky-web': 'Red Viscosa',
  'stockpile': 'Reserva',
  'stoked-sparksurfer': 'Surfeo Galvánico',
  'stomp': 'Pisotón',
  'stomping-tantrum': 'Pataleta',
  'stone-axe': 'Hacha Pétrea',
  'stone-edge': 'Roca Afilada',
  'stored-power': 'Poder Reserva',
  'storm-throw': 'Llave de Gira', // No.
  'storm-throw': 'Llave de Giro',
  'strange-steam': 'Vapor Extraño',
  'strength': 'Fuerza',
  'strength-sap': 'Absorbefuerza',
  'string-shot': 'Disparo Demora',
  'struggle': 'Combate',
  'struggle-bug': 'Estoicismo',
  'stuff-cheeks': 'Atiborramiento',
  'stun-spore': 'Paralizador',
  'submission': 'Sumisión',
  'substitute': 'Sustituto',
  'subzero-slammer': 'Crioembestida',
  'sucker-punch': 'Golpe Bajo',
  'sunny-day': 'Día Soleado',
  'sunsteel-strike': 'Meteoimpacto',
  'super-fang': 'Supercolmillo',
  'supercell-slam': 'Impacto Voltio',
  'superpower': 'Fuerza Bruta',
  'supersonic': 'Supersónico',
  'surf': 'Surf',
  'surging-strikes': 'Azote Fluido',
  'swagger': 'Contoneo',
  'swallow': 'Tragar',
  'sweet-kiss': 'Beso Dulce',
  'sweet-scent': 'Dulce Aroma',
  'swift': 'Rapidez',
  'switcheroo': 'Trapicheo',
  'swords-dance': 'Danza Espada',
  'synchronoise': 'Sincrorruido',
  'synthesis': 'Síntesis',
  'tackle': 'Placaje',
  'tail-glow': 'Ráfaga',
  'tail-slap': 'Plumerazo',
  'tail-whip': 'Látigo',
  'tailwind': 'Viento Afín',
  'take-down': 'Derribo',
  'take-heart': 'Corazón Curativo',
  'tar-shot': 'Disparo Alquitrán',
  'taunt': 'Mofa',
  'techno-blast': 'Tecno Shock',
  'tectonic-rage': 'Barrena de Tierra',
  'teeter-dance': 'Danza Caos',
  'telekinesis': 'Telequinesis',
  'teleport': 'Teletransporte',
  'temper-flare': 'Rabieta',
  'tera-blast': 'Terablast', // No.
  'tera-blast': 'Teraexplosión',
  'tera-starstorm': 'Teraluz Astral',
  'terrain-pulse': 'Pulso de Terreno',
  'thief': 'Ladrón',
  'thousand-arrows': 'Mil Flechas',
  'thousand-waves': 'Mil Temblores',
  'thrash': 'Golpe',
  'throat-chop': 'Mordaza',
  'thunder': 'Trueno',
  'thunder-bolt': 'Rayo',
  'thunder-cage': 'Electrojaula',
  'thunder-fang': 'Colmillo Rayo',
  'thunder-punch': 'Puño Trueno',
  'thunder-shock': 'Impactrueno',
  'thunder-wave': 'Onda Trueno',
  'thunderbolt': 'Rayo',
  'thunderous-kick': 'Patada Trueno',
  'tickle': 'Cosquillas',
  'tidy-up': 'Orden en el Área',
  'topsy-turvy': 'Patas Arriba',
  'torch-song': 'Canto Ardiente',
  'torment': 'Tormento',
  'toxic': 'Tóxico',
  'toxic-spikes': 'Púas Tóxicas',
  'toxic-thread': 'Hilo Tóxico',
  'trailblaze': 'Abrir Camino',
  'transform': 'Transformación',
  'tri-attack': 'Triataque',
  'trick': 'Truco',
  'trick-room': 'Espacio Raro',
  'triple-axel': 'Triple Axel',
  'triple-dive': 'Triple Inmersión',
  'triple-kick': 'Triple Patada',
  'trop-kick': 'Patada Tropical',
  'trump-card': 'As Oculto',
  'twineedle': 'Doble Ataque',
  'twister': 'Ciclón',
  'u-turn': 'Ida y Vuelta',
  'upper-hand': 'Golpe de Gracia',
  'uproar': 'Alboroto',
  'v-create': 'V de Fuego',
  'vacuum-wave': 'Onda Vacío',
  'veevee-volley': 'Veevee-Volley',
  'venom-drench': 'Trampa Venenosa',
  'venoshock': 'Carga Tóxica',
  'victory-dance': 'Danza Victoria',
  'vine-whip': 'Látigo Cepa',
  'vise-grip': 'Agarre',
  'vital-throw': 'Tiro Vital',
  'volt-switch': 'Voltiocambio',
  'volt-tackle': 'Placaje Eléctrico',
  'wake-up-slap': 'Espabilabofetón',
  'water-gun': 'Pistola Agua',
  'water-pledge': 'Voto Agua',
  'water-pulse': 'Pulso Agua',
  'water-shuriken': 'Shuriken de Agua',
  'water-spout': 'Salpicar',
  'waterfall': 'Cascada',
  'wave-crash': 'Envite Acuático',
  'weather-ball': 'Meteorobola',
  'wide-guard': 'Vastaguardia',
  'wild-bolt-storm': 'Tormenta de Rayos',
  'wild-charge': 'Voltio Cruel',
  'will-o-wisp': 'Fuego Fatuo',
  'wing-attack': 'Ataque Ala',
  'wish': 'Deseo',
  'withdraw': 'Refugio',
  'wood-hammer': 'Mazazo',
  'work-up': 'Avivar',
  'worry-seed': 'Abatidoras',
  'wrap': 'Constricción',
  'wrecking-ball': 'Bola de Demolición',
  'wrenching-fists': 'Puños Retorcidos',
  'x-scissor': 'Tijera X',
  'yawn': 'Bostezo',
  'zap-cannon': 'Electrocañón',
  'zen-headbutt': 'Cabezazo Zen',
  'zing-zap': 'Electropunzada',
  'zippy-zap': 'Zippy-Zap'
};
